import '../../styles/select.scss';

import { forwardRef, OptionHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';

import FormGroup from './FormGroup';
import { Label } from './Typography';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  labelSize?: 'l' | 'm' | 's';
  hint?: string;
  error?: string;
  errorHighlight?: boolean;
  children?: ReactNode;
  fullWidth?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ children, label, labelSize, hint, error, errorHighlight, fullWidth, ...props }: SelectProps, ref) => {
    const id = props.id ?? props.name;
    let selectClass = 'govuk-select';
    if (fullWidth) selectClass += ' govuk-!-width-full';
    if (error || errorHighlight) selectClass += ` govuk-select--error`;

    return (
      <FormGroup error={!!error}>
        {label && (
          <Label htmlFor={id} size={labelSize}>
            {label}
          </Label>
        )}
        {hint && (
          <div id={`${id}-hint`} className="govuk-hint">
            {hint}
          </div>
        )}
        {error && (
          <p id={`${id}-error`} className="govuk-error-message" style={{ marginRight: '10px' }}>
            <span className="govuk-visually-hidden">Error:</span> {error}
          </p>
        )}
        <select className={selectClass} id={id} ref={ref} {...props}>
          {children}
        </select>
      </FormGroup>
    );
  },
);
Select.displayName = 'Select';

export default Select;

interface OptionProps extends OptionHTMLAttributes<HTMLOptionElement> {
  text?: string;
}

export function Option({ text, ...props }: OptionProps) {
  return <option {...props}>{text}</option>;
}
